// css
import '../../scss/pages/page-contact-thanks.scss';

// components
import SplitText from '../components/SplitText';

// utils
import Foundation from '../utils/Foundation';
Foundation();

document.addEventListener('DOMContentLoaded', () => {
	new SplitText('.js-title-target', {
		target: '.js-title-text',
		transition: [90],
	});
});

window.addEventListener('load', () => {});
